import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: 'tw',    // 语言标识
    messages: {
        'tw': require('./lang/tw'),   // 繁體語言包
        'cn': require('./lang/cn'),    // 簡體語言包
        'en': require('./lang/en'),    // 英文語言包
        'jpa': require('./lang/jpn')    // 日語語言包
    },
})

export default  i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js